import { render } from "./actionLibrary.vue?vue&type=template&id=9b7ac7ac&scoped=true"
import script from "./actionLibrary.vue?vue&type=script&lang=js"
export * from "./actionLibrary.vue?vue&type=script&lang=js"

import "./actionLibrary.vue?vue&type=style&index=0&id=9b7ac7ac&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7ac7ac"]])

export default __exports__